import { defineStore } from "pinia";
import { ref, type Ref } from "vue";

export const useAppStore = defineStore("app", () => {
  const currentLanguage: Ref<string> = ref("sv-SE");

  const setCurrentLanguage = (language: string): void => {
    currentLanguage.value = language;
  };

  return {
    currentLanguage,
    setCurrentLanguage,
  };
});
